import { memo } from 'react';
import { IRequirementFeaturedImageProps } from './requirements-section.types';

const RequirementFeaturedImage: React.FC<IRequirementFeaturedImageProps> = ({
  title,
  url,
}) => (
  <div className='flex justify-center items-start mb-4'>
    <img
      src={url}
      alt={title}
      className='w-full object-contain'
      loading='lazy'
    />
  </div>
)

export default memo(RequirementFeaturedImage);
